import classNames from "classnames";
import { QUESTION_TYPE } from "constant";
import { useMemo } from "react";
import { useLanguageContext } from "store/LanguageProvider";
import { disableCopyPasteHandlers, parseAndEscapeCode } from "utils/helper";

export const Question = ({
  text,
  type,
  noMedia,
  className,
  breakerScreen = false,
}) => {
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);
  const isSpeech = useMemo(
    () =>
      [
        QUESTION_TYPE.SPEECH_SCRIPTED,
        QUESTION_TYPE.SPEECH_SPONTANEOUS,
      ].includes(type),
    [type]
  );

  const { rtlView, direction } = useLanguageContext();

  const questionClass = classNames(
    "my-[15px] text-cocoa-brown sm:my-[0px] sm:h-[90%] sm:pr-[40px]", 
    "text-base font-medium leading-6 tracking-[-0.2px]",
    {
    // "text-xl font-semibold leading-[26px] tracking-[-0.5px] sm:text-2xl":
    //   text.length <= 120,
    // "text-base font-medium leading-6 tracking-[-0.2px]":
    //   text.length > 120 && !isSpeech,
    "sm:my-[15px]": type === QUESTION_TYPE.FREE_TEXT,
    "mt-0": noMedia,
    "text-center":
      isSpeech || (type === QUESTION_TYPE.FREE_TEXT && text.length <= 120),
    "w-[calc(100vw-36px)] sm:w-full": isHtml,
    "text-parchment": !!className && isHtml, // making text white if breaker screen
    "text-right-ar-normal" : rtlView
  });

  return (
    <>
      {!isHtml ? (
        <h2
          dir={"auto"}
          className={className ?? questionClass}
          {...disableCopyPasteHandlers}
        >
          {text.split("\n").map((sentence, index) =>
            index > 0 ? (
              <>
                <br />
                {sentence}
              </>
            ) : (
              sentence
            )
          )}
        </h2>
      ) : (
        <div
          dir={"auto"}
          className={classNames(questionClass, "html", {
            "breakerScreen": breakerScreen,
          })}
          dangerouslySetInnerHTML={{ __html: parseAndEscapeCode(text) }}
          {...disableCopyPasteHandlers}
        />
      )}
    </>
  );
};
